var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "table_settings_positions",
        title: "Настройки столбцов",
        centered: "",
        "hide-footer": "",
      },
      model: {
        value: _vm.active,
        callback: function ($$v) {
          _vm.active = $$v
        },
        expression: "active",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "m-table-settings",
          class: { "m-table-settings-driver": _vm.isDriverTableSettings },
        },
        [
          _c("div", { staticClass: "m-table-settings__inputs" }, [
            _vm.withCategories !== undefined
              ? _c(
                  "div",
                  { staticClass: "m-table-settings__input" },
                  [
                    _c("c-select", {
                      staticClass: "m-table-settings__input-categories",
                      attrs: {
                        placeholder: "Все группы",
                        items: _vm.selectCategories,
                        multiple: "",
                        searchable: "",
                      },
                      model: {
                        value: _vm.selectedCategories,
                        callback: function ($$v) {
                          _vm.selectedCategories = $$v
                        },
                        expression: "selectedCategories",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "m-table-settings__input" },
              [
                _c("c-input", {
                  staticClass: "m-table-settings__input-search",
                  attrs: {
                    placeholder: "Поиск по столбцам",
                    icon: "search",
                    "placeholder-style": "italic",
                    clearable: "",
                  },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                }),
              ],
              1
            ),
            _vm.withGrouped !== undefined
              ? _c(
                  "div",
                  {
                    staticClass:
                      "m-table-settings__input m-table-settings__input__switcher",
                  },
                  [
                    _c("c-switcher", {
                      staticClass: "m-table-settings__input-group",
                      attrs: { label: "Группировать должности по категориям" },
                      model: {
                        value: _vm.grouped,
                        callback: function ($$v) {
                          _vm.grouped = $$v
                        },
                        expression: "grouped",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "m-table-settings__content" }, [
            _c(
              "div",
              {
                staticClass: "m-table-settings__results",
                on: { scroll: _vm.handleScroll },
              },
              _vm._l(_vm.localColumns, function (column, columnIndex) {
                return _c(
                  "div",
                  {
                    key: columnIndex,
                    staticClass: "m-table-settings__column",
                    class: {
                      "m-table-settings__column_show": _vm.isOpenedCategory(
                        column.id
                      ),
                      "m-table-settings__column_category":
                        column.isCategory === 1,
                    },
                  },
                  [
                    column.isVisible
                      ? [
                          _vm.withGrouped && column.isVisible
                            ? _c(
                                "div",
                                {
                                  staticClass: "m-table-settings__item",
                                  class: {
                                    "m-table-settings__item_parent":
                                      column.isCategory === 1,
                                    "m-table-settings__item_parent_shadow":
                                      column.isCategory === 1 && _vm.scrolled,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "m-table-settings__item-wrapper",
                                      on: {
                                        click: (e) =>
                                          _vm.clickColumnCheckbox(e, column),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-table-settings__item-checkbox",
                                          class: {
                                            "m-table-settings__item-checkbox_check":
                                              _vm.isColumnCheck(column),
                                            "m-table-settings__item-checkbox_half":
                                              _vm.isColumnHalf(column),
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_check",
                                              attrs: {
                                                width: "11",
                                                height: "8",
                                                viewBox: "0 0 11 8",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M3.29312 7.6838C2.90259 7.29327 2.90259 6.66011 3.29312 6.26958L8.29712 1.26555C8.68764 0.875025 9.32081 0.875025 9.71133 1.26555C10.1019 1.65607 10.1019 2.28924 9.71133 2.67976L4.70733 7.6838C4.31681 8.07432 3.68364 8.07432 3.29312 7.6838Z",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M4.70733 7.6838C5.09786 7.29327 5.0978 6.66011 4.70727 6.26958L1.73445 3.29679C1.34393 2.90626 0.710761 2.90626 0.320237 3.29679C-0.0702873 3.68731 -0.0702873 4.32048 0.320237 4.711L3.29312 7.6838C3.68364 8.07432 4.31681 8.07432 4.70733 7.6838Z",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c("div", {
                                            staticClass:
                                              "m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_square",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-table-settings__item-label",
                                        },
                                        [_vm._v(_vm._s(column.label))]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "m-table-settings__item-toggle",
                                      on: {
                                        click: (e) =>
                                          _vm.categoryToggle(e, column.id),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-table-settings__item-toggle-icon",
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "8",
                                                height: "5",
                                                viewBox: "0 0 8 5",
                                                fill: "none",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z",
                                                  fill: "#0066FF",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z",
                                                  fill: "#0066FF",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "m-table-settings__column-children",
                              class: {
                                "m-table-settings__column-children-without-category":
                                  _vm.withGrouped !== undefined,
                              },
                            },
                            _vm._l(
                              column.columns,
                              function (column, columnIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: columnIndex,
                                    staticClass: "m-table-settings__column",
                                  },
                                  [
                                    column.isVisible
                                      ? [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "m-table-settings__item",
                                              on: {
                                                click: (e) =>
                                                  _vm.clickColumnCheckbox(
                                                    e,
                                                    column
                                                  ),
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "m-table-settings__item-checkbox",
                                                  class: {
                                                    "m-table-settings__item-checkbox_check":
                                                      _vm.isColumnCheck(column),
                                                    "m-table-settings__item-checkbox_half":
                                                      _vm.isColumnHalf(column),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_check",
                                                      attrs: {
                                                        width: "11",
                                                        height: "8",
                                                        viewBox: "0 0 11 8",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M3.29312 7.6838C2.90259 7.29327 2.90259 6.66011 3.29312 6.26958L8.29712 1.26555C8.68764 0.875025 9.32081 0.875025 9.71133 1.26555C10.1019 1.65607 10.1019 2.28924 9.71133 2.67976L4.70733 7.6838C4.31681 8.07432 3.68364 8.07432 3.29312 7.6838Z",
                                                        },
                                                      }),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M4.70733 7.6838C5.09786 7.29327 5.0978 6.66011 4.70727 6.26958L1.73445 3.29679C1.34393 2.90626 0.710761 2.90626 0.320237 3.29679C-0.0702873 3.68731 -0.0702873 4.32048 0.320237 4.711L3.29312 7.6838C3.68364 8.07432 4.31681 8.07432 4.70733 7.6838Z",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c("div", {
                                                    staticClass:
                                                      "m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_square",
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "m-table-settings__item-label",
                                                },
                                                [_vm._v(_vm._s(column.label))]
                                              ),
                                            ]
                                          ),
                                          column.columns.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "m-table-settings__column-children-children",
                                                },
                                                _vm._l(
                                                  column.columns,
                                                  function (
                                                    column,
                                                    columnIndex
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: columnIndex,
                                                        staticClass:
                                                          "m-table-settings__column",
                                                      },
                                                      [
                                                        column.isVisible
                                                          ? _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "m-table-settings__item",
                                                                on: {
                                                                  click: (e) =>
                                                                    _vm.clickColumnCheckbox(
                                                                      e,
                                                                      column
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "m-table-settings__item-checkbox",
                                                                    class: {
                                                                      "m-table-settings__item-checkbox_check":
                                                                        _vm.isColumnCheck(
                                                                          column
                                                                        ),
                                                                      "m-table-settings__item-checkbox_half":
                                                                        _vm.isColumnHalf(
                                                                          column
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "svg",
                                                                      {
                                                                        staticClass:
                                                                          "m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_check",
                                                                        attrs: {
                                                                          width:
                                                                            "11",
                                                                          height:
                                                                            "8",
                                                                          viewBox:
                                                                            "0 0 11 8",
                                                                          xmlns:
                                                                            "http://www.w3.org/2000/svg",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "path",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                d: "M3.29312 7.6838C2.90259 7.29327 2.90259 6.66011 3.29312 6.26958L8.29712 1.26555C8.68764 0.875025 9.32081 0.875025 9.71133 1.26555C10.1019 1.65607 10.1019 2.28924 9.71133 2.67976L4.70733 7.6838C4.31681 8.07432 3.68364 8.07432 3.29312 7.6838Z",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "path",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                d: "M4.70733 7.6838C5.09786 7.29327 5.0978 6.66011 4.70727 6.26958L1.73445 3.29679C1.34393 2.90626 0.710761 2.90626 0.320237 3.29679C-0.0702873 3.68731 -0.0702873 4.32048 0.320237 4.711L3.29312 7.6838C3.68364 8.07432 4.31681 8.07432 4.70733 7.6838Z",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("div", {
                                                                      staticClass:
                                                                        "m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_square",
                                                                    }),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "m-table-settings__item-label",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        column.label
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
          _c(
            "div",
            { staticClass: "m-table-settings__actions" },
            [
              _c("c-button", {
                staticClass: "m-table-settings__actions-item",
                attrs: { size: "large", label: "Сбросить" },
                on: { click: _vm.reset },
              }),
              _c("c-button", {
                staticClass: "m-table-settings__actions-item",
                attrs: {
                  disabled: _vm.isEmptyChoiceColumns(_vm.localColumns),
                  label: "Применить",
                  color: "blue",
                  size: "large",
                },
                on: { click: _vm.submit },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }